const columnAccent = {
  "card-row card-primary":   { bg: "#e8f0fe", accent: "#1a73e8", text: "#1a73e8" },
  "card-row card-info":      { bg: "#e0f7fa", accent: "#00838f", text: "#00838f" },
  "card-row card-secondary": { bg: "#f5f5f5", accent: "#616161", text: "#616161" },
  "card-row card-success":   { bg: "#e8f5e9", accent: "#2e7d32", text: "#2e7d32" },
};

const CardRow = ({ children, title, type, CardTools, count }) => {
  const theme = columnAccent[type] || columnAccent["card-row card-secondary"];

  return (
    <div style={{
      flex: "1 1 0",
      minWidth: 0,
      background: "#f8f9fa",
      borderRadius: "12px",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    }}>
      {/* Column header */}
      <div style={{
        padding: "14px 16px 12px",
        borderBottom: `3px solid ${theme.accent}`,
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}>
        <span style={{
          fontWeight: 700,
          fontSize: "0.88rem",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          color: "#424242",
        }}>
          {title}
        </span>
        {typeof count === "number" && (
          <span style={{
            background: theme.bg,
            color: theme.text,
            fontWeight: 700,
            fontSize: "0.75rem",
            padding: "2px 8px",
            borderRadius: "20px",
          }}>
            {count}
          </span>
        )}
        {CardTools && (
          <div style={{ marginLeft: "auto" }}>
            <CardTools />
          </div>
        )}
      </div>

      {/* Cards area */}
      <div style={{
        flex: 1,
        overflowY: "auto",
        padding: "12px 10px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        minHeight: "200px",
      }}>
        {children}
      </div>
    </div>
  );
};

export default CardRow;
